import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [languageSelected, setLanguageSelected] = useState(
    () => localStorage.getItem("languageSelected") || 0
  );

  useEffect(() => {
    localStorage.setItem("languageSelected", languageSelected);
  }, [languageSelected]);

  return (
    <LanguageContext.Provider
      value={{
        languageSelected,
        setLanguageSelected,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageContext = () => useContext(LanguageContext);
